import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { from, Observable } from 'rxjs';
import { FulleStockService } from "../services/api/fulle/fulle-stock/fulle-stock.service";

@Injectable({
  providedIn: 'root'
})

export class StockResolver implements Resolve<boolean> {
  constructor(private stockService: FulleStockService) { }
  resolve(): Observable<any> {
    // console.log("ou la");
    return from(this.stockService.getStocks().toPromise());
  }
}
